export default function themeShape({ variables }) {
    return {
        borderRadius: parseInt(variables.border_radius_small),
    };
}
//# sourceMappingURL=shape.js.map